"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgAngleUpIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 15', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M13.97.628a2.045 2.045 0 0 0-2.947 0L.61 11.34a2.19 2.19 0 0 0 0 3.032 2.045 2.045 0 0 0 2.948 0L12.5 5.174l8.942 9.192a2.045 2.045 0 0 0 2.948 0 2.19 2.19 0 0 0 0-3.033L13.977.62z' }) })));
});
exports.default = (0, react_1.memo)(SvgAngleUpIcon);
